import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AppShell } from "@/components/app-shell";
import { requireRole } from "@/lib/session";
import { supabase } from "@/integrations/supabase/client";
import { LearnerFeesView } from "@/components/fees/fee-shared";

export const Route = createFileRoute("/parent/fees")({
  ssr: false,
  beforeLoad: () => requireRole("parent"),
  head: () => ({ meta: [{ title: "Fees — MAKAI" }] }),
  component: ParentFeesPage,
});

function ParentFeesPage() {
  const [learners, setLearners] = useState<any[]>([]);
  const [currency, setCurrency] = useState("UGX");

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data: parents } = await supabase.from("parents").select("id,school_id").eq("user_id", user.id);
      const parentIds = (parents ?? []).map((p) => p.id);
      if (parentIds.length === 0) return;
      const { data: links } = await supabase.from("parent_learner_links").select("learner_id").in("parent_id", parentIds);
      const learnerIds = Array.from(new Set((links ?? []).map((l) => l.learner_id)));
      if (learnerIds.length === 0) return;
      const { data: ls } = await supabase.from("learners").select("id,first_name,last_name,school_id,admission_number").in("id", learnerIds);
      setLearners(ls ?? []);
      const schoolIds = Array.from(new Set((ls ?? []).map((l) => l.school_id).filter((x): x is string => !!x)));
      if (schoolIds.length > 0) {
        const { data: school } = await supabase.from("schools").select("currency").eq("id", schoolIds[0]).maybeSingle();
        if (school?.currency) setCurrency(school.currency);
      }
    })();
  }, []);

  return (
    <AppShell role="parent" title="Fees & payments" subtitle="View invoices, pay via MTN, Airtel, card or bank — and track confirmations.">
      <LearnerFeesView learners={learners} schoolCurrency={currency} />
    </AppShell>
  );
}
